import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-stamp-filled",
  "use": "rt-base-stamp-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-stamp-filled\"><path d=\"M287 820.6h450c38.9 0 75.5-17.7 100.2-48.5 24.6-30.8 34.1-70.9 26-110.1-12.3-59.9-67-103.3-129.9-103.3h-98.9v-24.8c74-44.6 118.8-125.7 117.3-213.1-2.1-126.6-105.2-233.6-229.8-238.7-66.3-2.7-128.4 21.3-175.9 67.6s-73.7 108.6-73.7 175.4c0 85.6 44.8 165.2 117.3 208.9v24.8h-98.9c-62.9 0-117.5 43.4-129.9 103.3-8.1 39.1 1.4 79.1 26 109.9 24.7 30.9 61.2 48.6 100.2 48.6zM872 862.1H152c-22 0-40 18-40 40s18 40 40 40h720c22 0 40-18 40-40s-18-40-40-40z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/stamp-filled.svg
// module id = 1795
// module chunks = 137